export enum StakeUnstake {
  STAKE = 'Stake',
  UNSTAKE = 'Unstake'
}